<template>
  <woot-modal
    :show="showAccountModal"
    :on-close="() => $emit('close-account-modal')"
    class="account-selector--modal"
  >
    <woot-modal-header
      :header-title="$t('SIDEBAR_ITEMS.CHANGE_ACCOUNTS')"
      :header-content="$t('SIDEBAR_ITEMS.SELECTOR_SUBTITLE')"
    />
    <div class="account-selector--search">
      <fluent-icon icon="search" class="search-icon" />
      <input
        ref="searchInput"
        v-model="searchQuery"
        type="text"
        class="content-search"
        data-testid="account-selector-search"
        :placeholder="$t('SIDEBAR_ITEMS.SEARCH_ACCOUNTS_PLACEHOLDER')"
      />
    </div>
    <div class="account-selector--wrap">
      <p v-if="!filteredAccounts.length" class="account-selector--empty">
        {{ $t('SIDEBAR_ITEMS.NO_ACCOUNTS_FOUND') }}
      </p>
      <div
        v-for="account in filteredAccounts"
        :key="account.id"
        class="account-selector"
      >
        <button
          class="button expanded clear link"
          tabindex="0"
          @click="onChangeAccount(account.id)"
        >
          <span class="button__content">
            <label :for="account.name" class="account-details--wrap">
              <div class="account--name">{{ account.name }}</div>
              <div class="account--role">{{ account.role }}</div>
            </label>
          </span>
          <fluent-icon
            v-show="account.id === accountId"
            class="selected--account"
            icon="checkmark-circle"
            type="solid"
            size="24"
          />
        </button>
      </div>
    </div>

    <div
      v-if="globalConfig.createNewAccountFromDashboard"
      class="modal-footer delete-item"
    >
      <button
        class="button success large expanded nice"
        @click="$emit('show-create-account-modal')"
      >
        {{ $t('CREATE_ACCOUNT.NEW_ACCOUNT') }}
      </button>
    </div>
  </woot-modal>
</template>

<script>
import { mapGetters } from 'vuex';
import { filterByName } from 'dashboard/helper/searchHelper';

export default {
  props: {
    showAccountModal: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      searchQuery: '',
    };
  },
  computed: {
    ...mapGetters({
      accountId: 'getCurrentAccountId',
      currentUser: 'getCurrentUser',
      globalConfig: 'globalConfig/get',
    }),
    sortedAccounts() {
      return [...this.currentUser.accounts].sort((a, b) =>
        a.name.localeCompare(b.name, 'pt-BR', { sensitivity: 'base' })
      );
    },
    filteredAccounts() {
      return filterByName(this.sortedAccounts, this.searchQuery);
    },
  },
  watch: {
    showAccountModal(isOpen) {
      if (!isOpen) return;

      this.searchQuery = '';
      this.focusSearchInput();
    },
  },
  mounted() {
    if (this.showAccountModal) this.focusSearchInput();
  },
  methods: {
    focusSearchInput() {
      this.$nextTick(() => {
        if (this.$refs.searchInput) {
          this.$refs.searchInput.focus();
        }
      });
    },
    onChangeAccount(accountId) {
      const accountUrl = `/app/accounts/${accountId}/dashboard`;
      window.location.href = accountUrl;
    },
  },
};
</script>
<style lang="scss" scoped>
.account-selector--search {
  align-items: center;
  display: flex;
  margin: var(--space-normal) var(--space-normal) 0;
  position: relative;

  .search-icon {
    color: var(--b-700);
    left: var(--space-one);
    position: absolute;
  }

  .content-search {
    border-color: var(--s-100);
    height: 3.8rem;
    margin: 0;
    padding-left: var(--space-large);
    width: 100%;
  }
}
.account-selector--wrap {
  overflow: auto;
  max-height: calc(100vh - 50px);
  margin-top: var(--space-normal);
}
.account-selector--empty {
  color: var(--s-600);
  padding: var(--space-one) var(--space-normal);
  text-align: center;
}
.account-selector {
  padding-top: 0;
  padding-bottom: 0;
  .button {
    display: flex;
    justify-content: space-between;
    padding: var(--space-one) var(--space-normal);

    &:focus {
      background: var(--w-50);
      text-decoration: underline;
    }

    .account-details--wrap {
      text-align: left;
      .account--name {
        cursor: pointer;
        font-size: var(--font-size-medium);
        font-weight: var(--font-weight-medium);
        line-height: 1;
      }

      .account--role {
        cursor: pointer;
        font-size: var(--font-size-mini);
        text-transform: capitalize;
      }
    }
  }
}
</style>
